import { useState, type ComponentProps } from 'react';
import { TabHeader, GameRoster, TeamRoster, View } from '@rivallapp/volosports-components';

const TabEnums = {
  LINEUP: 'Lineup',
  RSVPS: 'RSVPs',
};

const RosterManagement = ({
  gameId,
  teamId,
  isAdmin,
  leagueId,
  isPast,
  updateGameRoster,
  setUpdateGameRoster,
  setSelectedDropin,
}: ComponentProps<typeof GameRoster>) => {
  const [activeTab, setActiveTab] = useState(TabEnums.LINEUP);

  const onSwitchTab = (tab: string) => setActiveTab(tab);

  return (
    <View marginX={3} maxWidth={350}>
      <View marginY={8}>
        <TabHeader
          values={Object.values(TabEnums)}
          onSwitch={onSwitchTab}
          selectedValue={activeTab}
        />
      </View>
      {activeTab === TabEnums.RSVPS ? (
        <TeamRoster teamId={teamId} gameId={gameId} isAdmin={isAdmin} />
      ) : (
        <GameRoster
          gameId={gameId}
          teamId={teamId}
          isAdmin={isAdmin}
          leagueId={leagueId}
          isPast={isPast}
          updateGameRoster={updateGameRoster}
          setUpdateGameRoster={setUpdateGameRoster}
          setSelectedDropin={setSelectedDropin}
        />
      )}
    </View>
  );
};

export default RosterManagement;
